import { IDeliveryAddress, IDiningMethods, IPickUpOption } from "@/types/common-types";
import { prefix } from ".";
import AddressIcon from "../svg/AddressIcon";
import PickUpIcon from "../svg/PickUpIcon";
import DineInSmallIcon from "../svg/DineInSmallIcon";
import { ITable } from "@/types/table-types";
import { TFunction } from "i18next";
import Skeleton from "../Skeleton";

interface IDiningMethodsPanelProps {
  t: TFunction<"common", undefined>;
  loading: boolean;
  showContent: boolean;
  showOption: boolean;
  type: IDiningMethods | undefined;
  table: ITable | undefined;
  addressList: IDeliveryAddress[];
  pickUpOption: IPickUpOption | undefined;
  onClick: () => void;
};

const DiningMethodsPanel: React.FC<IDiningMethodsPanelProps> = (props) => {
  const {
    t,
    showContent,
    type,
    table,
    loading,
    showOption,
    addressList,
    pickUpOption,
    onClick,
  } = props;

  const handleClick = () => {
    onClick()
  };

  const addressRecord = addressList[0];

  return (
    <div className={`${prefix} ${showContent ? '' : 'hidden'}`}>
      <Skeleton
        loading={loading}
        row={2}
        rowWidth={['90%', '80%']}
      />
      {
        !loading && showContent &&
        <>
          {type === IDiningMethods.DELIVERY && <AddressIcon className={`${prefix}-icon`} />}
          {type === IDiningMethods.TAKEAWAY && <PickUpIcon className={`${prefix}-icon`} />}
          {type === IDiningMethods.DINE_IN && <DineInSmallIcon className={`${prefix}-icon`} />}
          {
            showOption && type === IDiningMethods.DELIVERY && addressRecord &&
            <div className={`${prefix}-content`}>
              <div className={`${prefix}-content-title`}>{addressRecord.address}</div>
              <div className={`${prefix}-content-street`}>{addressRecord.street}</div>
              <div>{addressRecord.name} - {addressRecord.phone}</div>
            </div>
          }
          {
            showOption && type === IDiningMethods.TAKEAWAY && pickUpOption &&
            <>
              <div className={`${prefix}-content`}>
                <div className={`${prefix}-content-title`}>Pick-up: {pickUpOption.delivery_date}</div>
                <div className={`${prefix}-content-details`}>{pickUpOption.name} - {pickUpOption.phone}</div>
              </div>
              <div onClick={handleClick} className={`${prefix}-btn`}>
                {pickUpOption ? t('edit') : t('addNew')}
              </div>
            </>
          }
          {
            showOption && type === IDiningMethods.DINE_IN && table &&
            <div className={`${prefix}-content`}>
              <div className={`${prefix}-content-title`}>Table: {table.name}</div>
              {/* <div className={`${prefix}-content-title`}>{table.updated_at}</div> */}
            </div>
          }
        </>
      }
    </div>
  )
};

export default DiningMethodsPanel;